import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import InputProfile from './InputProfile.react';
import DropdownProfile from './DropdownProfile.react';
import DOBProfile from './DOBProfile.react';
import TextareaProfile from './TextareaProfile.react';
import DOB from '../../form/DOB.react';
import AjaxPromises from '../../../utils/AjaxPromises';

import imageCompression from 'browser-image-compression';
class PrimaryIdentification extends React.Component {

    constructor(props) {
        super(props);

        var id = this.props.guest.identifications;

        var mjStateId = false;

        for (var i=0; i<id.length; i++) {
            switch (id[i].type)
            {
            case 'MJStateIDNo':
                mjStateId = id[i];
                break;
            }
        }

        this.state = {
            confirmClear : false,

            mjStateIdNo        : mjStateId ? mjStateId.number : false,
            mjStateIdStartDate : mjStateId && mjStateId.StartDate.length > 0 ? moment(mjStateId.StartDate).format('YYYY/MM/DD') : '',
            mjStateIdExp       : mjStateId && mjStateId.ExpirationDate.length > 0 ? moment(mjStateId.ExpirationDate).format('YYYY/MM/DD') : '',
            mjStateIdImg       : mjStateId ? mjStateId.image_url : false,
            mjStateIdLoad      : false,
        };

        this.onChange = this.onChange.bind(this);
        this.onMjStateIdChange = this.onMjStateIdChange.bind(this);
        this.saveMjStateId = this.saveMjStateId.bind(this);
        this.removeMjStateId = this.removeMjStateId.bind(this);
        this.didInfoUpdate = this.didInfoUpdate.bind(this);
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    onMjStateIdChange(e) {
        var self = this;

        var reader = new FileReader();
        imageCompression(e.target.files[0], {
            maxSizeMB: 0.049,
            maxWidthOrHeight: 1080,
        })
            .then((compressedFile) => {
                reader.readAsDataURL(compressedFile);
            })
            .catch((error) => {
                NotificationActions.addNotification({type: 'error', body: error.message});
            });

        reader.onload = function(upload) {
            self.setState({ mjStateIdImg : self.dataURItoBlob(upload.target.result) }, () => {
                self.saveMjStateId();
            });
        }.bind(this);
    }

    saveMjStateId() {
        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;
        formData.MJStateIDNo    = this.state.mjStateIdNo;
        formData.MJStateIDStartDate = this.state.mjStateIdStartDate;
        formData.ExpirationDate = this.state.mjStateIdExp;
        formData.ImgItem        = this.state.mjStateIdImg;

        this.setState({ mjStateIdLoad : true }, () => {
            AjaxPromises.POST(EndPoints.UPDATE_PRIMARY_ID,
                formData).then(res => {

                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'MMJ ID information failed to update'});
                    } else {
                        NotificationActions.addNotification({type:'success',body:'MMJ ID information updated successfully'});

                        GuestActions.loadFullGuest(self.props.guest.Guest_id);
                    }
                }
            );
        });
    }

    removeMjStateId() {
        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;

        this.setState({ mjStateIdLoad : true }, () => {
            AjaxPromises.POST(EndPoints.DELETE_PRIMARY_ID,
                formData).then(res => {
                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not removed'});
                    } else {
                        self.setState({ confirmClear : false, mjStateIdImg : false }, () => {
                            NotificationActions.addNotification({type:'success', body:'Image removed successfully'});

                            GuestActions.loadFullGuest(self.props.guest.Guest_id);
                        });
                    }
                }
            );
        });
    }

    dataURItoBlob(dataURI) {
        var byteString = false;

        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = dataURI.split(',')[1];
        }

        return byteString;
    }

    didInfoUpdate() {
        var id = this.props.guest.identifications;

        var mjStateId = false;

        for (var i=0; i<id.length; i++) {
            switch (id[i].type)
            {
            case 'MJStateIDNo':
                mjStateId = id[i];
                break;
            }
        }

        if (mjStateId.number !== this.state.mjStateIdNo)
            return true;

        if (moment(mjStateId.ExpirationDate).format('MM/DD/YYYY') !== this.state.mjStateIdExp)
            return true;

        return false;
    }

    render() {
        var self  = this;
        var { selectedLocation } = UserStore.getState();

        var guest = this.props.guest;

        var mjStateIdImg = this.state.mjStateIdImg;
        var didInfoUpdate = this.didInfoUpdate();

        return (
            <div className='row'>
                <div className='col-6'>
                    { this.state.mjStateIdImg ?
                        <img
                            src={'data:image/png;base64, '+this.state.mjStateIdImg}
                            className='view-identification__image' />
                    :
                        <img
                            src='/assets/id_placeholder.png'
                            className='view-identification__image' />
                    }
                </div>

                <div className='col-6'>
                    <div className='row'>
                        <div className='col-4' style={{display: 'flex', 'flex-direction': 'column', 'justifyContent': 'space-around'}}>
                            <div>ID No.</div>
                            {selectedLocation.MJIDStartDateField && <div>Start Date</div>}
                            <div>Expiration Date</div>
                        </div>
                        <div className='col-8'>

                            <InputProfile
                                field='mjStateIdNo'
                                disabled={guest.IsAnonymous}
                                value={this.state.mjStateIdNo}
                                onChange={this.onChange}/>
                            {selectedLocation.MJIDStartDateField &&
                                <DOB
                                    AllowInFuture
                                    field='mjStateIdStartDate'
                                    disabled={guest.IsAnonymous}
                                    value={this.state.mjStateIdStartDate}
                                    onChange={this.onChange} />
                            }
                            <DOB
                                AllowInFuture
                                field='mjStateIdExp'
                                disabled={guest.IsAnonymous}
                                value={this.state.mjStateIdExp}
                                onChange={this.onChange} />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12'>
                            <div
                                className={'btn-green view-identification__btn '+(!guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={() => { 
                                    if (!guest.IsAnonymous) {
                                        $('#view-identification__mjstateid').click(); 
                                    }
                                }}>

                                NEW
                            </div>

                            <div
                                className={'btn-green view-identification__btn '+(mjStateIdImg && !guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={() => { this.setState({ confirmClear: (mjStateIdImg && !guest.IsAnonymous ? this.state.mjStateIdNo : false) }); }}>

                                CLEAR
                            </div>

                            <div
                                className={'btn-green view-identification__btn '+(didInfoUpdate && !guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={!guest.IsAnonymous ? this.saveMjStateId : null}>

                                SAVE
                            </div>

                            <input
                                type='file'
                                disabled={guest.IsAnonymous}
                                id='view-identification__mjstateid'
                                className='view-identification__file'
                                onChange={this.onMjStateIdChange} />
                        </div>
                    </div>

                    { this.state.confirmClear &&
                        <div className='popup'>
                            <div className='popup__content view-identification__clear'>
                                <div className='popup-header'>
                                    CLEAR IMAGE
                                    <div
                                        className='popup-close'
                                        onClick={() => { this.setState({ confirmClear : false }); }}>

                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>
                                </div>

                                <button
                                    onClick={() => { this.setState({ confirmClear : false }); }}>

                                    CANCEL
                                </button>

                                <button
                                    onClick={self.removeMjStateId}>

                                    CLEAR
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default PrimaryIdentification;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/PrimaryIdentification.react.jsx